// Add your JS customizations here
"use strict";
import AOS from 'aos';

import Swiper, { Navigation,  EffectFade, Autoplay, Controller } from 'swiper';
Swiper.use([Navigation, EffectFade, Autoplay, Controller]);


AOS.init({
	duration: 700,
	once: true
});

//Set is-pinned classname for stuck header
jQuery(function($){
	(function (d) {
		const el = d.querySelector("#site-header");
		const observer = new IntersectionObserver(
			([e]) => {
				el.classList.toggle("is-pinned", e.intersectionRatio < 1);
			},
			{ threshold: [1] }
		);
		observer.observe(d.querySelector("#header-observer"));
	})(document);
});

// Featured Projects slider
var projectSlider = document.querySelector('.projects-slider .swiper-wrapper');
var projectThumbnailSlider = document.querySelector('.projects-thumbnail-slider .swiper-wrapper');
if(projectSlider) {

	for (var i = projectSlider.children.length; i >= 0; i--) {
		let randNum = Math.random() * i | 0;
		projectSlider.appendChild(projectSlider.children[randNum]);
		projectThumbnailSlider.appendChild(projectThumbnailSlider.children[randNum]);
	}

	if(projectSlider.children.length < 3) {

		function duplicateChildNodes(parentSelector){
				var parent = document.querySelector(parentSelector);
				NodeList.prototype.forEach = Array.prototype.forEach;
				var children = parent.childNodes;
				children.forEach(function(item){
				var cln = item.cloneNode(true);
				parent.appendChild(cln);
			});
		};
		duplicateChildNodes('.projects-slider .swiper-wrapper');
		duplicateChildNodes('.projects-thumbnail-slider .swiper-wrapper');

	}

	let individualSlides = document.querySelectorAll('.projects-slider .project-media-slider');
	individualSlides.forEach(function(el){

		let wrapper = el.querySelector('.swiper-wrapper');
		for (var i = wrapper.children.length; i >= 0; i--) {
			let randNum = Math.random() * i | 0;
			wrapper.appendChild(wrapper.children[randNum]);
		}

		const elSlider = new Swiper(el, {
			loop: true,
			slidesPerView: 1,
			allowTouchMove: false,
			effect: "fade",
			speed: 600,
			fadeEffect: {
				crossFade: true
			},
			autoplay: {
				delay: 4000,
			},
		});
	});

	var thumbEl = document.querySelector('.projects-thumbnail-slider');

	const projectThumbnailSwiper = new Swiper('.projects-thumbnail-slider', {
		loop: true,
		slidesPerView: "auto",
		spaceBetween: 0,
		speed: 400,
		allowTouchMove: false,
		updateOnWindowResize: false,
		on: {
			slideChangeTransitionEnd: (swiper) => {
				thumbEl.classList.remove('move-right');
				thumbEl.classList.remove('move-left-double');
				if(thumbEl.querySelector('.before-active')) {
					thumbEl.querySelector('.before-active').classList.remove('before-active');
				}
			},
			slidePrevTransitionStart: (swiper) => {
				thumbEl.classList.add('move-right');
			},
		}
	});

	const projectSwiper = new Swiper('.projects-slider', {
		loop: true,
		slidesPerView: 1,
		allowTouchMove: false,
		loopedSlides: projectSlider.children.length,
		effect: "fade",
		speed: 400,
		autoHeight: true,
		fadeEffect: {
			crossFade: true
		},
		navigation: {
			nextEl: document.querySelector('#project-slider-nav .swiper-button-next'),
			prevEl: document.querySelector('#project-slider-nav .swiper-button-prev')
		},

	});

	document.querySelector('#project-slider-nav .swiper-button-prev').addEventListener('click', function(e){
		thumbEl.classList.add('move-right');
	});

	projectThumbnailSlider.addEventListener('mousedown', function(e){
		let sldIdx = e.target.closest('.swiper-slide').dataset.swiperSlideIndex;
		if(sldIdx) {
			const itm = e.target.closest('.swiper-slide');
			const prevPrev = itm.previousElementSibling.previousElementSibling;
			if(prevPrev && prevPrev.classList.contains('swiper-slide-active')) {
				itm.previousElementSibling.classList.add('before-active');
				thumbEl.classList.add('move-left-double');
				setTimeout(function(){
					itm.previousElementSibling.classList.remove('before-active');
					thumbEl.classList.remove('move-left-double');
				}, 200);
			}
			const idx = Array.from(itm.parentElement.children).indexOf(itm);
			projectThumbnailSwiper.slideTo(idx);
		}
	}, true);

	projectThumbnailSwiper.controller.control = projectSwiper;
	projectSwiper.controller.control = projectThumbnailSwiper;

}

//CTA Slider
document.querySelectorAll('.cta-slider').forEach(ctaSlider => {
	// Shuffle slider items
	const sliderWrapper = ctaSlider.querySelector('.swiper-wrapper');
	for (var i = sliderWrapper.children.length; i >= 0; i--) {
		sliderWrapper.appendChild(sliderWrapper.children[Math.random() * i | 0]);
	}
	const prevBtnEl = ctaSlider.nextElementSibling.querySelector('.swiper-button-prev');
	const nextBtnEl = ctaSlider.nextElementSibling.querySelector('.swiper-button-next');
	const ctaSwiper = new Swiper(ctaSlider, {
		loop: sliderWrapper.children.length > 1 ? true : false,
		slidesPerView: 1,
		spaceBetween: 0,
		effect: "fade",
		speed: 600,
		autoplay: {
			delay: 4000,
		},
		navigation: {
			nextEl: nextBtnEl,
			prevEl: prevBtnEl,
		}
	});
});

//Photo Slider
document.querySelectorAll('.photo-slider').forEach(photoSlider => {
	const prevBtnEl = photoSlider.nextElementSibling.querySelector('.swiper-button-prev');
	const nextBtnEl = photoSlider.nextElementSibling.querySelector('.swiper-button-next');
	const ctaSwiper = new Swiper(photoSlider, {
		loop: photoSlider.querySelector('.swiper-wrapper').children.length > 1 ? true : false,
		slidesPerView: 1,
		spaceBetween: 0,
		effect: "fade",
		fadeEffect: {
			crossFade: true
		},
		speed: 600,
		autoplay: {
			delay: 4000,
		},
		navigation: {
			nextEl: nextBtnEl,
			prevEl: prevBtnEl,
		}
	});
});

// Interior Hero Slider
var interiorHeroSlider = document.querySelector('.interior-hero-slider');
if(interiorHeroSlider) {
	const interiorHeroSlider = new Swiper('.interior-hero-slider', {
		loop: true,
		slidesPerView: 1,
		spaceBetween: 0,
		autoplay: {
			delay: 5000,
		},
		effect: "fade",
		speed: 700,
		fadeEffect: {
			crossFade: true
		},
		navigation: {
			nextEl: document.querySelector('.interior-hero-slider-nav-wrap .swiper-button-next'),
			prevEl: document.querySelector('.interior-hero-slider-nav-wrap .swiper-button-prev')
		}
	});
}

document.addEventListener('aos:in:animated-stat', function(e) {
	var el = jQuery(e.detail);

	el.find('.animated-num').each(function() {
		jQuery(this).prop('Counter',0).animate({
			Counter: jQuery(this).text()
		}, {
			duration: 1500,
			easing: 'swing',
			step: function (now) {
			jQuery(this).text(Math.ceil(now).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1"));
		}
		});
	});
});


jQuery(function($){

	// Lists split across columns, make them appear as one continuous list when stacked
	$('.wp-block-columns').each(function(){
		var columnWrap = $(this);
		var listTags = ['ul', 'ol'];

		if( $('.wp-block-column', columnWrap).length != 2 ){
			return;
		}

		var col1LastTag = $('.wp-block-column', columnWrap).eq(0).find('> *:last-child');
		var col2FirstTag = $('.wp-block-column', columnWrap).eq(1).find('> *:first-child');

		if(
			jQuery.inArray(col1LastTag.prop('tagName').toLowerCase(), listTags) !== -1 && // first column first tag is list
			jQuery.inArray(col2FirstTag.prop('tagName').toLowerCase(), listTags) !== -1 &&  // second column first tag is list
			col1LastTag.prop('tagName').toLowerCase() == col2FirstTag.prop('tagName').toLowerCase() // first and second column lists are same type
		){
			columnWrap.addClass('split-list');
		}
	});

	$('#header-search-form').on('shown.bs.collapse', function(){
		$(this).find('input').focus();
	});

	$('.header-search').click(function(event){
		event.stopPropagation();
	});

	$(window).click(function(){
		$('#header-search-form').collapse('hide');
	});

	$('.homepage-hero .scroll-down').click(function(e){
		e.preventDefault();
		$('.homepage-hero').next()[0].scrollIntoView({behavior: "smooth"});
	});

	$('#site-header .navbar-nav li.menu-item-has-children').each(function(){
		$(this).append('<button class="mobile-subnav-toggle" aria-label="Sub menu toggle"><i class="fa-regular fa-plus"></i></button>');
	});
	$('#site-header').on('click', '.mobile-subnav-toggle', function(){
		$(this).find('i').toggleClass('fa-plus fa-minus');
		$(this).siblings('ul').slideToggle(200);
	});


	$('#site-header').click(function(e){
		e.stopPropagation();
	});
	$(window).click(function() {
		$('#site-header .navbar-collapse').collapse('hide');
	});

	$('.modal').appendTo('body');

	// Selectric
	$('select').on('selectric-init', function(event, element, data) {
		if( !$(this).hasClass('no-placeholder') && $('option:first', this).val() == '' ){ // if first option has empty value, hide it to treat it as a placeholder
			data.$element.closest('.selectric-wrapper').find('.selectric-scroll > ul > li:first-child').addClass('visually-hidden'); // hide first option
		}
	});
	$('select:not(.allow-keyboard)').selectric({
		maxHeight: 320,
		disableOnMobile: false,
		nativeOnMobile: false,
		onOpen: function(){
			$('.selectric-input').blur(); // prevent keyboard from opening on mobile
		},
		onInit: function(element, data){
			$('.selectric-input').attr('aria-hidden', 'false');
		},
	});
	$('select.allow-keyboard').selectric({
		maxHeight: 320,
		disableOnMobile: false,
		nativeOnMobile: false,
		onInit: function(element, data){
			$('.selectric-input').attr('aria-hidden', 'false');
		},
	});

	$('.select-link').change(function(){
		let value = $(this).val();
		if(value) {
			window.location.href = value;
		}
	});

	$('.projects-slider').on({
		mouseenter: function() {
			$(this).closest('.slide-inner').addClass('hovered');
		},
		mouseleave: function() {
			$(this).closest('.slide-inner').removeClass('hovered');
		}
	}, '.slide-image a, .slide-text .slide-title a');

	// People Page
	$('.toggle-leadership').click(function(){
		$(this).toggleClass('leadership-active');
		$('.section-people-grid').toggleClass('leadership-only');
		AOS.refreshHard();
	});

	// More Related Projects
	$('.section-related-projects').on('click', '.more-related-projects-btn', function(e){
		e.preventDefault();
		var btnWrap = $(this).closest('div');
		var btnNext = btnWrap.clone();
		var pageNum = $(this).data('page');
		var pid = $(this).data('pid');
		var holder = $(this).closest('.more-btn-wrap').prev('.row');
		btnWrap.addClass('loading').append('<div class="spinner-wrap"><span class="spinner-border text-primary" role="status" aria-hidden="true"></span></div>');
		btnNext.find('a').attr('data-page', pageNum + 1);
		btnNext.find('a').attr('href', function(i, a){
			return a.replace( /(pg\/)(\d+)/i, function(match, p1, p2){
				p2++;
				return p1 + p2;
			});
		});

		let jsonUrl = localVars.root + 'gale/related-projects?page=' + pageNum + '&pid=' + pid;
		if($(this).data('ismobile')) {
			jsonUrl += '&mobile=true';
		}

		$.getJSON(jsonUrl, (results) => {
			btnWrap.remove();
			if(results.entries) {
				holder.append(results.entries);
				if(results.pagination) {
					holder.after(btnNext);
				}
			}
		});
	});

	// Filters
	$('select').change(function(){
		if( $(this).hasClass('submit-on-change') ){
			$(this).closest('form').submit();
		}
	});
	
	// Filter Reset Button
	$('.btn-reset').on('click', function(event){
		event.preventDefault();
		
		// Hide button
		$(this).removeClass('d-block').addClass('d-none');
		
		// Reset inputs (all but select)
		$(this).closest('form').find(":input")
			.not(':button, :submit, :reset, :hidden, select')
			.val('')
			.prop('checked', false)
			.prop('selected', false);
		
		// Reset select fields
		$(this).closest('form').find('select').each(function(){
			var hasSubmitOnChange = false;
			if( $(this).hasClass('submit-on-change') ){
				hasSubmitOnChange = true;
				$(this).removeClass('submit-on-change');
			}
			$(this).prop('selectedIndex', 0).selectric('refresh');
			if( hasSubmitOnChange ){
				$(this).addClass('submit-on-change');
			}
		});
	});

	// Pagination
	$('#content').on('click', '#ajax-btn-wrap a', function(e){
		e.preventDefault();
		var target = $(this).attr('href');
		var holderID = '#ajax-grid';
		var holder = $(holderID);
		var btnWrapID = '#ajax-btn-wrap';
		var btnWrap = $(btnWrapID);
		btnWrap.addClass('loading').append('<div class="spinner-wrap"><span class="spinner-border text-primary" role="status" aria-hidden="true"></span></div>');

		$.get(target, function(response){
			var entries = $(response).find(holderID).children();
			var generatedBtnWrap = $(response).find(btnWrapID);
			btnWrap.remove();
			holder.append(entries);
			if(generatedBtnWrap.length) {
				generatedBtnWrap.insertAfter(holder);
			}
		});
	});
	
	// Ajax Filtering
	$('.hero-filters-wrap.ajax form').on('submit', function(e){
		e.preventDefault();
		var form = $(this);
		var holderID = $(this).parent().data('holder-id');
		var holder = $('#'+holderID);
		var serialized = form.serialize();

		// Show loading spinner
		holder.empty().append('<div class="more-btn-wrap py-5"><div class="spinner-wrap"><div class="spinner-border text-primary" role="status"><span class="visually-hidden">Loading...</span></div></div></div>');

		// Scroll down to holder
		$('html, body').stop().animate({
        scrollTop: holder.offset().top - $('#main-nav').outerHeight()
    }, 250);
		
		// Update address bar
		if (typeof(history.replaceState) != "undefined") {
			history.replaceState({}, '', form.attr('action') + '?' + form.serialize());  
    }
		
		$.ajax({
			type: "GET",
			url: form.attr('action'),
			data: form.serialize(),
			dataType: 'html',
			success: function(response) {
				holder.empty(); // remove loading spinner
				var newHtml = $(response).find('#'+holderID);
				holder.append(newHtml);
				
				// Check if form is empty
				var allEmpty = true;
				$(':input', form).each(function() {
					if ($(this).val() !== '') {
						allEmpty = false;
					}
				});
				
				// Form was empty, hide the reset button
				if(allEmpty){
					$('.btn-reset', form).removeClass('d-block').addClass('d-none');
				// Form was not empty, show the reset button
				} else {
					$('.btn-reset', form).removeClass('d-none').addClass('d-block');
				}
			}
		});
		
	});
	
	// Submit input[search] when cleared with "x" button
	$('input[type="search"]').on('search', function(event){
		$(this).closest('form').trigger('submit');
	});

});


// 100 viewport width fix
function setVw() {
  let vw = document.documentElement.clientWidth / 100;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
}
setVw();
window.addEventListener('resize', setVw);